import { Link } from '@inertiajs/react';
import { GrInstagram } from 'react-icons/gr';
import { BsTwitterX } from 'react-icons/bs';
import { BsYoutube } from 'react-icons/bs';

import footer_logo from '../../frontend/assets/footer_logo.svg';


const Footer = () => {
  return (
    <footer className='bg-black p-4 text-center text-white  w-full'>
      <div className='max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8'>
        <figure className='flex-shrink-0'>
          <img
            src={footer_logo}
            alt='YottaNet Technologies Logo'
            className='h-10'
          />
        </figure>

        <nav className='flex flex-wrap justify-center md:justify-start gap-x-6 gap-y-2 text-lg font-medium'>
          <Link
            href='#'
            className='hover:text-gray-300 transition-colors duration-200'
          >
            Home
          </Link>
          <Link
            href='#service'
            className='hover:text-gray-300 transition-colors duration-200'
          >
            Services
          </Link>
          <Link
            href='#store'
            className='hover:text-gray-300 transition-colors duration-200'
          >
            Store
          </Link>
          <Link
            href='#about'
            className='hover:text-gray-300 transition-colors duration-200'
          >
            About us
          </Link>
          <Link
            href='#blog'
            className='hover:text-gray-300 transition-colors duration-200'
          >
            Blog
          </Link>
          <Link
            href='#contact'
            className='hover:text-gray-300 transition-colors duration-200'
          >
            Contact us
          </Link>
        </nav>

        {/* Social Media Icons */}
        <div className='flex gap-4'>
          <Link
            href='#'
            className='bg-gray-800 p-2 rounded-full hover:bg-gray-700 transition-colors duration-200'
          >
            <GrInstagram className='w-6 h-6 text-white' />
          </Link>
          <Link
            href='#'
            className='bg-gray-800 p-2 rounded-full hover:bg-gray-700 transition-colors duration-200'
          >
            <BsTwitterX className='w-6 h-6 text-white' />
          </Link>
          <Link
            href='#'
            className='bg-gray-800 p-2 rounded-full hover:bg-gray-700 transition-colors duration-200'
          >
            <BsYoutube className='w-6 h-6 text-white' />
          </Link>
        </div>
      </div>
      <hr className='border-gray-700 my-8' />
      <p className='text-center text-sm text-gray-400'>
        &copy; 2025 Yottanet Technologies. All rights reserved.
      </p>
    </footer>
  );
}

export default Footer